const BYTES_PER_MB = 1024 * 1024;

export interface FileFieldLimits {
  multiple: boolean;
  maxFiles: number;
  maxSizeMB: number | undefined;
}

export const resolveFileFieldLimits = (
  options: { min?: number; max?: number; maxFileSize?: number } | undefined,
  defaultMaxFiles: number
): FileFieldLimits => {
  const min = options?.min ?? 0;
  const max = options?.max ?? defaultMaxFiles;

  return {
    multiple: min > 1 || max > 1,
    maxFiles: max,
    maxSizeMB: options?.maxFileSize === undefined ? undefined : options.maxFileSize / BYTES_PER_MB,
  };
};
